import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { Image } from 'components/Image/Image';

export class SimpleHeroUnwrapped extends PureComponent {
  onDwell() {
    const { onView } = this.props;
    if (onView) {
      onView();
    }
  }

  render() {
    const {
      backgroundColor,
      body,
      children,
      cta,
      footer,
      imageAlignment = 'left',
      imageAlt,
      imageUrl,
      title,
      titleSize,
    } = this.props;

    return (
      <div
        className={classNames({
          'simple-hero': true,
          [`simple-hero--${imageAlignment}`]: true,
          'simple-hero--no-image': !imageUrl,
          [`bg--${backgroundColor}`]: true,
        })}>
        <section>
          <div className="simple-hero__content">
            {title && <h2 className={`text--${titleSize || 'xl'}`}>{title}</h2>}
            {body && <p className="simple-hero__body">{body}</p>}
            {cta}
          </div>
          {imageUrl && (
            <div className="simple-hero__image">
              <Image url={imageUrl} alt={imageAlt} />
            </div>
          )}
        </section>
        {children}
        {footer && <p className="simple-hero__footer">{footer}</p>}
      </div>
    );
  }
}

SimpleHeroUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['light', 'white']),
  body: PropTypes.node,
  children: PropTypes.node,
  cta: PropTypes.node,
  footer: PropTypes.node,
  imageAlignment: PropTypes.oneOf(['left', 'right']),
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  onView: PropTypes.func,
  title: PropTypes.node,
  titleSize: PropTypes.string,
};

export const SimpleHero = trackDwell(SimpleHeroUnwrapped);
